import React, { useState } from 'react';

import cn from 'classnames';

import { Panel } from '@admin/components/helpers/panel';

export const CollapsiblePanel: React.FC<{
  panelId?: string;
  title: string;
  className?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}> = ({ panelId, title, className, children, footer }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={cn('panel', className)} id={panelId}>
      <Panel.Header>
        <Panel.Collapse collapsed={collapsed} onChange={setCollapsed} />
        <h3 className="panel-title">{title}</h3>
      </Panel.Header>
      {!collapsed && (
        <>
          <Panel.Body>{children}</Panel.Body>
          {footer && <Panel.Footer align="right">{footer}</Panel.Footer>}
        </>
      )}
    </div>
  );
};
